import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useIdentity } from '~/app/lib/redux/selectors/identity-selector';
import Login from '../login/login';
import BrandedLogin from '../branded-login/branded-login';

const Authentication = ({
  requiresAuth,
  authRoleRequired,
  onSuccess,
  loginModalCopyOverride,
  loginPageCopyOverride,
  children,
  // branded Login
  useBrandedLogin,
  brandedBackgroundImage,
  brandedIcon,
  brandedTitle,
  brandedSubtitle,
  customCtaText,
  topLoginBoxColor,
  bottomLoginBoxColor,
  topLoginBoxMargin,
  bottomLoginBoxMargin,
  outputAnimatedArrowAboveCta,
  animatedImageUrl,
  loginPageTitle,
  loginPageSubtitle,
}) => {
  const { current, isSignedIn } = useIdentity();

  const isEmployee = _.includes(current?.roles, 'nerdwallet/employee');
  const hasAuth =
    isEmployee || _.includes(current?.roles, `${authRoleRequired}`);
  const LoginComponent = useBrandedLogin ? BrandedLogin : Login;

  return requiresAuth && !hasAuth ? (
    <LoginComponent
      onSuccess={onSuccess}
      isSignedIn={isSignedIn}
      loginModalCopyOverride={loginModalCopyOverride}
      loginPageCopyOverride={loginPageCopyOverride}
      // branded Login
      brandedBackgroundImage={brandedBackgroundImage}
      brandedIcon={brandedIcon}
      brandedTitle={brandedTitle}
      brandedSubtitle={brandedSubtitle}
      customCtaText={customCtaText}
      topLoginBoxColor={topLoginBoxColor}
      bottomLoginBoxColor={bottomLoginBoxColor}
      topLoginBoxMargin={topLoginBoxMargin}
      bottomLoginBoxMargin={bottomLoginBoxMargin}
      outputAnimatedArrowAboveCta={outputAnimatedArrowAboveCta}
      animatedImageUrl={animatedImageUrl}
      loginPageTitle={loginPageTitle}
      loginPageSubtitle={loginPageSubtitle}
    />
  ) : (
    children
  );
};

Authentication.propTypes = {
  requiresAuth: PropTypes.bool,
  authRoleRequired: PropTypes.string,
  onSuccess: PropTypes.string,
  loginModalCopyOverride: PropTypes.string,
  loginPageCopyOverride: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
  // branded Login
  useBrandedLogin: PropTypes.bool,
  brandedBackgroundImage: PropTypes.string,
  brandedIcon: PropTypes.string,
  brandedTitle: PropTypes.string,
  brandedSubtitle: PropTypes.string,
  customCtaText: PropTypes.string,
  topLoginBoxColor: PropTypes.string,
  bottomLoginBoxColor: PropTypes.string,
  topLoginBoxMargin: PropTypes.number,
  bottomLoginBoxMargin: PropTypes.number,
  outputAnimatedArrowAboveCta: PropTypes.bool,
  animatedImageUrl: PropTypes.string,
  loginPageTitle: PropTypes.object,
  loginPageSubtitle: PropTypes.object,
};

Authentication.displayName = 'Authentication';

export default Authentication;
